// extracted by mini-css-extract-plugin
export default {"tips__container":"loadingtips_tips__container__zHSjv","icon":"loadingtips_icon__8TuXJ"};